import { render, staticRenderFns } from "./ClassBioPanel.vue?vue&type=template&id=987feee2&"
import script from "./ClassBioPanel.vue?vue&type=script&lang=js&"
export * from "./ClassBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports